module.exports = __webpack_public_path__ + "img/proof_of_address.e4abb465.svg";